import Filter from "components/ui/Filter";
import Spinner from "components/ui/Spinner";
import Pagination from "components/ui/Pagination";
import { useEffect, useState } from "react";
import { getWinnersPublic } from "services/realization.service";
import { categories, RealizationEvItem } from "types/realization";
import CardEvaluated from "components/ui/CardEvaluated";
import { FaExclamation } from "react-icons/fa6";
import StepTitle from "components/ui/StepTitle";
import BrandBB from "../../assets/img/brand_bb.svg";


const Classificadas = () => {
  const [loadingItens, setLoadingItens] = useState(false);
  const [categories, setCategories] = useState<categories[]>([]);
  const [realizations, setRealizations] = useState<RealizationEvItem[]>([]);
  const [filteredRealization, setFilteredRealization] = useState<
    RealizationEvItem[]
  >([]);

  const [filter, setFilter] = useState<{
    category?: string;
    searchTerm?: string;
    prefix?: number;
  }>({});

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 12;

  const [currentItens, setCurrentItens] = useState<RealizationEvItem[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingItens(true);
        const data = await getWinnersPublic();

        const items = data ? data.flatMap((item) => item.realizations) : [];

        let newCategories = data
          ? data.map((item) => {
              return {
                name: `${item.categoryName}(${
                  item.realizations.filter(
                    (r) => r.realization.classificada === true
                  ).length || 0
                })`,
                _id: item.categoryName,
              };
            })
          : [];

        newCategories.unshift({
          name: `Todas (${items.length})`,
          _id: -1,
        });

        setCategories(newCategories);

        setRealizations(
          items.sort(
            (a, b) =>
              (b.realization.classificada ? 1 : 0) -
              (a.realization.classificada ? 1 : 0)
          )
        );
        setFilteredRealization(items);

        const totalPages = Math.ceil(items.length / perPage);
        setTotalPages(totalPages);
      } catch (e) {
      } finally {
        setLoadingItens(false);
      }
    };

    fetchData();
  }, [currentPage, perPage]);

  useEffect(() => {
    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;
    let newdata = filteredRealization.slice(indexOfFirstItem, indexOfLastItem);

    setCurrentItens(newdata);

    const totalPages = Math.ceil(filteredRealization.length / perPage);
    setTotalPages(totalPages);
  }, [currentPage, perPage, filteredRealization]);

  const filterData = (
    data: RealizationEvItem[],
    category?: string,
    title?: string,
    prefix?: number
  ) => {
    console.log(category);
    let filteredData = data.filter((item) => {
      const categoriaMatch =
        category && category !== "-1" ? item.categoria === category : true;

      const tituloMatch = title
        ? item.title.toLocaleLowerCase().includes(title)
        : true;
      const prefixMatch =
        prefix !== undefined
          ? String(item.prefixo).includes(String(prefix))
          : true;

      return categoriaMatch && tituloMatch && prefixMatch;
    });

    console.log(filteredData);

    return filteredData;
  };

  useEffect(() => {
    let result = filterData(
      realizations,
      filter.category,
      filter.searchTerm?.toLocaleLowerCase(),
      filter.prefix
    );

    setFilteredRealization(result);
    setCurrentPage(1);
  }, [filter, realizations]);

  return (
    <>
      {loadingItens ? (
        <div className="flex items-start justify-center w-full h-screen">
          <div className="flex flex-col">
            <Spinner />
            <span className="text-center text-blue-bb">Carregando...</span>
          </div>
        </div>
      ) : (
        <>
          <header className="bg-blue-bb text-yellow-bb py-[11px] px-[17.5px]">
            <div className="flex items-center justify-between w-full">
              <h1 className="flex items-center gap-[17px] pr-4 mr-4 text-yellow-bb font-bold text-lg font-title">
                <img src={BrandBB} alt="" /> Prêmio BB
              </h1>
            </div>
          </header>
          <div className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 py-8">
              <StepTitle
                title={
                  "Saiba mais sobre as realizações finalistas que estão aqui hoje!"
                }
                description={
                  "Conheça as 41 iniciativas mais votadas pelos Vice-Presidentes e Presidenta e que participam da etapa final de votação do Prêmio BB."
                }
              />

              <div className="mb-6">
                <Filter
                  categories={categories}
                  enableCategoryFilter={true}
                  enablePrefixFilter={true}
                  placeholderField={"Buscar por titulo de realizações"}
                  onChange={(key, value) => {
                    setFilter((prev) => ({ ...filter, [key]: value }));
                  }}
                />
              </div>

              {currentItens.length === 0 ? (
                <div className="flex items-center justify-center my-5">
                  <FaExclamation />
                  <p className="text-lg font-semibold text-gray-bb-1">
                    Não há realizações para esse filtro!
                  </p>
                </div>
              ) : (
                <div className="grid-cols-1 mx-4 md:grid md:mx-0 md:grid-cols-2 gap-7 content">
                  {currentItens.map(
                    (item: RealizationEvItem, index: number) => (
                      <CardEvaluated
                        data={item}
                        onlyResult={true}
                        key={index}
                        isResult
                      />
                    )
                  )}
                </div>
              )}

              {totalPages > 0 && (
                <div className="mt-8">
                  <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPage={setCurrentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Classificadas;
